import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "countrySelector", "stateSelector"];

    connect() {
      $('form').bootstrapMaterialDesign();
    }

  newAddress(event) {
    event.preventDefault();
    const url = this.data.get("url");

    showModal("#new-address-modal");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".new-address-form-container").innerHTML = html;
        initializeCountrySelect2("#new-address-modal");
        initializeTooltips();
        initializeAddressAutocomplete();
        $("form").bootstrapMaterialDesign();
      })
      .catch(error => {
        showErrorMessage(error);
        hideModal("#new-address-modal");
      });
  }

  createAddress(event) {
    event.preventDefault();
    const controller = this,
      form = this.formTarget;

    axios
      .post(form.action, $(form).serialize())
      .then(response => {
        hideModal("#new-address-modal");
        controller.refreshAddressesTab(response, true);
        showNotification(
          "success",
          "The new account address has been created successfully"
        );
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  editAddress(event) {
    event.preventDefault();
    const url = this.data.get("url");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".edit-address-form-container").innerHTML = html;
        showModal("#edit-address-modal");
        initializeCountrySelect2("#edit-address-modal");
        initializeTooltips();
        initializeAddressAutocomplete();
        applyPostcodeCriterias($("#account_address_AddressCountry").val());
        $("form").bootstrapMaterialDesign();
      })
      .catch(error => {
        showErrorMessage(error);
        hideModal("#edit-address-modal");
      });
  }

  updateAddress(event) {
    event.preventDefault();
    const controller = this,
      form = this.formTarget;

    axios
      .patch(form.action, $(form).serialize())
      .then(response => {
        hideModal("#edit-address-modal");
        controller.refreshAddressesTab(response, false);

        showNotification(
          "success",
          "The account address has been updated successfully"
        );
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }

  deleteAddress(event) {
    event.preventDefault();
    const controller = this,
      url = this.data.get("url"),
      authenticityToken = this.data.get("authenticityToken");

    bootbox.confirm({
      message: "Are you sure you want to delete this address?",
      title: "Delete Address",
      callback: function (result) {
        if (result) {
          axios
            .delete(url, { data: { authenticity_token: authenticityToken } })
            .then(response => {
              controller.refreshAddressesTab(response, true);
              showNotification(
                "success",
                "The account address has been deleted"
              );
            })
            .catch(error => {
              showErrorMessage(error);
            });
        }
      }
    });
  }

  showAddresses(event) {
    if (!document.querySelector(".account-addresses-datatable.dataTable")) {
      initializeAccountAddressesDataTable();
    }
  }

  refreshAddressesTab(response, addressesNumChanged) {
    $(".account-addresses-datatable").DataTable().ajax.reload();

    if (addressesNumChanged) {
      $(".addresses-tab-title").text(`Addresses (${response.data.count})`);

      if (response.data.can_create) {
        $("a.new-address-icon").show();
      } else {
        $("a.new-address-icon").hide();
      }
    }
  }
}
